import {createContext} from 'react';

import {DEFAULT_LANGUAGE} from 'constants/language';
import {DateFormat, TimeFormat} from 'enums';
import {MFAStatus, UserContextProps} from 'types';

export const UserContext = createContext<UserContextProps>({
    auth: {
        sessionAccessOnly: false
    },
    settings: {
        featuresAvailability: {
            screenRecorder: false,
            workingHours: false,
            outgoingMessages: false,
            clientsConnections: false,
            requestAppointment: false,
            afterSessionFiles: false,
            chatGPT: false,
            watsonx: false,
            mastra: false,
            claude: false,
            sip: false,
            deepgram: false,
            avatar: false,
            guestEnabled: false,
            whatsapp: false,
            oauth: false,
            assistantEnabled: false,
            conversationSummary: false,
            clientSessionCustomerLogo: false,
            clientSessionWhiteLabel: false,
            clientSessionLiveHelp: false,
            clientSessionInteractiveChat: false,
            userInfoSchemaEditor: false,
            conversations: false,
            internalLiveAgent: false,
            deescalation: false,
            preSessionFlow: false,
            compliance: false,
            agentChatbot: false,
            activitiesManagement: false,
        },
        providerPurposes: {},
        appointment: {
            client: {
                notification: {
                    email: {
                        enabled: false
                    }
                }
            },
            agent: {
                notification: {
                    email: {
                        enabled: false
                    }
                }
            }
        },
        security: {
            mfa: {
                status: MFAStatus.Disabled
            }
        },
        common: {
            timeZone: 'UTC',
            dateFormat: DateFormat.DDMMYYYY,
            timeFormat: TimeFormat.TwentyFour,
            logo: null,
            language: DEFAULT_LANGUAGE,
            incomingSessionSound: {
                enabled: true
            },
            systemDateValidation: {
                enabled: true,
                attempts: 3,
                possibleDiff: 3
            }
        },
        afterSession: {
            externalFiles: {
                filePipelineEnabled: false,
                count: 0
            }
        },
        registration: {
            withPassword: true,
            withEmailConfirmation: true
        },
        clientConnect: {
            notification: {
                sms: {
                    enabled: false,
                    messages: []
                },
                email: {
                    enabled: false,
                    messages: []
                },
                whatsapp: {
                    enabled: false,
                    messages: []
                }
            }
        },
        clientInvitation: {
            enabled: false,
            sms: {
                enabled: false
            },
            email: {
                enabled: false
            }
        },
        userSession: {
            maxAssistants: 1,
            maxGuests: 1,
            maxParticipants: 2,
            requireScreenRecorder: false,
            textChatHistory: {
                enabled: false
            },
            avatarHistory: {
                enabled: false
            },
            virtualBackground: {
                enabled: false
            },
            audioTranscription: {
                enabled: false
            },
            audioVideoTranscription: {
                enabled: false
            }
        }
    },
    reloadSettings: null,
    socket: null,
});
